import { Link, useLocation } from "react-router-dom";
import { Home, Trophy, Shield } from "lucide-react";
import { LOGO_URL } from "../lib/format";

export default function Header() {
  const { pathname } = useLocation();
  // Do NOT surface an admin entry in the main nav. Access is direct via /admin URL only.

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 backdrop-blur-xl"
      style={{ background: "rgba(9, 10, 15, 0.75)" }}
      data-testid="app-header"
    >
      <div className="max-w-6xl mx-auto px-3 sm:px-6 py-3 flex items-center justify-between gap-2">
        <Link to="/" className="flex items-center gap-2 sm:gap-3 min-w-0 shrink" data-testid="header-logo-link">
          <img src={LOGO_URL} alt="Speed Freaks" className="h-9 sm:h-10 w-9 sm:w-10 object-contain shrink-0" />
          <div className="leading-none min-w-0">
            <div className="font-display text-lg sm:text-2xl text-white tracking-wide whitespace-nowrap">
              ROLÊ<span style={{ color: "#00E5FF" }}>SPEEDFREAKS</span>
            </div>
            <div className="label-caps mt-1 hidden sm:block">Race Team</div>
          </div>
        </Link>

        <nav className="flex items-center gap-1 sm:gap-2 shrink-0">
          <Link
            to="/"
            className={`hidden sm:flex items-center gap-2 text-sm px-3 py-2 border border-transparent rounded-sm transition-colors ${
              pathname === "/" ? "text-[#00E5FF] border-white/10" : "text-white/80 hover:text-white hover:border-white/10"
            }`}
            data-testid="nav-home-link"
          >
            <Home size={16} /> Home
          </Link>
          <Link
            to="/ranking"
            className={`flex items-center gap-2 text-sm px-2 sm:px-3 py-2 border border-transparent rounded-sm transition-colors ${
              pathname === "/ranking" ? "text-[#39FF14] border-white/10" : "text-white/80 hover:text-[#39FF14] hover:border-white/10"
            }`}
            data-testid="nav-ranking-link"
          >
            <Trophy size={16} /> <span className="hidden sm:inline">Ranking</span>
          </Link>
          <Link
            to="/passaporte"
            className={`flex items-center gap-2 text-sm px-2 sm:px-3 py-2 border rounded-sm transition-colors ${
              pathname.startsWith("/passaporte")
                ? "text-[#00E5FF] border-[#00E5FF]"
                : "text-white border-white/10 hover:border-[#00E5FF]"
            }`}
            data-testid="nav-passport-link"
          >
            <Shield size={14} /> <span className="hidden xs:inline sm:inline">Passport</span>
            <span className="inline xs:hidden sm:hidden">Passport</span>
          </Link>
        </nav>
      </div>
    </header>
  );
}
